import React from 'react';
/* Helpers */
import { addThousandSeparator, getIfInternalThemeIsBaseSimulator } from '../../../helpers/utils';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setModalThunk } from '../../../redux/actions/index';

export const SimulationRecap = () => {
  const { amount, payment, numberOfInstallments, TAN, TAEG } = useSelector(state => state.currentSimulation);
  const internalTheme = useSelector(state => state.internalTheme);
  const dispatch = useDispatch();
  const setModal = (modal, options) => dispatch(setModalThunk(modal, options));

  const getMinMaxStringWithSpanValue = (min, max, options = {
    label: false,
    symbol: "",
    numberOfDigitsAfterDecimalPoint: 0
  }) => {
    let result = [];

    if (addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint) === addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)) {
      const minMaxString = [<span className="value">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];

      result = [...minMaxString];
    } else {
      let minMaxString = [];

      if (options.label) {
        minMaxString = ['da MIN', <span className="value" key="1">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>, ' a MAX ', <span className="value" key="2">{`${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];
      } else {
        minMaxString = ['da ', <span className="value" key="1">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>, ' a ', <span className="value" key="2">{`${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];
      }

      result = [...minMaxString];
    }
    
    return result;
  }

  const getButtonIfEnabled = () => {
    return getIfInternalThemeIsBaseSimulator(internalTheme);
  }

  return (
    <div className="loan-main-boxs-rpp">
      <p>Importo richiesto {addThousandSeparator(amount.current)} €</p>
      <p>Numero rate {getMinMaxStringWithSpanValue(numberOfInstallments.min, numberOfInstallments.max)}</p>
      <p>Importo rata <span className="value">{addThousandSeparator(payment.current)} €</span></p>
      <p><span>TAN</span> {getMinMaxStringWithSpanValue(TAN.min, TAN.max, { label: false, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })}</p>
      <p><span>TAEG</span> {getMinMaxStringWithSpanValue(TAEG.min, TAEG.max, { label: false, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })}</p>
      {
        getButtonIfEnabled() 
        &&
        (
          <div className="loan-box-link-rpp"><button className="loan__info-button loan__info-button--white" type="button" onClick={function() { setModal('moreInfo', { isVisible: true }) }}>Vuoi saperne di più?</button></div>
        )
      }
    </div>
  );
}
